export const phoneLogServiceBaseUrl = "https://api.dev.phonelog.warnerbros.com";
export const phoneLogSharedServiceBaseUrl = "";
export const OKTA_CLIENT_ID = "0oa17xmzacpMHqcBK0h8";
export const OKTA_ISSUER_URL = "https://ssodev.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + "/callback";
export const OKTA_URL = "https://ssodev.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";
